























import { BFormSelect, BFormSelectOption, BInputGroup } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';

interface TextEditor {
    key: string;
    label: string;
}

@Component({
    name: 'Editor',
    components: {
        'b-input-group': BInputGroup,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'vue-editor': VueEditor,
    },
})
export default class Editor extends Vue {
    enableEditor: boolean = false;
    format: string = '';
    formats: TextEditor[] = [
        {
            key: 'wysiwyg',
            label: 'WYSIWYG',
        },
        {
            key: 'html',
            label: 'HTML',
        },
        {
            key: 'text',
            label: 'Text',
        },
    ];

    @Prop() value!: string;
    @Prop() placeholder!: string;

    get buffer() {
        return this.value;
    }
    set buffer(value: string) {
        this.$emit('input', value);
    }

    mounted() {
        const regex = /<\/?[a-z][\s\S]*>/i;
        const containsHtml = regex.test(this.value);

        this.format = containsHtml ? 'wysiwyg' : 'text';
    }

    onInput() {
        if (this.format === 'text') {
            const div = document.createElement('div');
            div.innerHTML = this.value;
            this.$emit('input', div.innerText);
        }
    }
}
